import { getTriggerElementsFromElement } from '../../helpers/dom/get-trigger-elements-form-element';
import { eventNamespaceFactory } from '../../helpers/events/event-namespace-factory';

export class Dialog {
	triggers: HTMLElement[];
	disableClose = false;
	rect: DOMRect | null = null;
	currentTarget: HTMLElement | null = null;

	private eventNamespaceFn = eventNamespaceFactory('opten.dialog');


	constructor(private element: HTMLDialogElement) {
		this.triggers = getTriggerElementsFromElement(this.element);

		this.triggers.forEach((trigger) =>
			trigger.addEventListener('click', (e) => {
				this.currentTarget = (e.currentTarget as HTMLElement);
				if(this.currentTarget.hasAttribute('data-align-dialog')) {
					this.currentTarget.classList.add('is-active');
					this.rect = this.currentTarget.getBoundingClientRect();
				} else {
					this.currentTarget = null;
					this.rect = null;
				}
				this.toggle();
			}),
		);

		this.disableClose =
			this.element.hasAttribute('data-disable-close') &&
			this.element.getAttribute('data-disable-close')?.toUpperCase() == 'TRUE';

		this.element.addEventListener('click', (event) => {
			const rect = this.element.getBoundingClientRect();
			const isInDialog =
				rect.top <= event.clientY &&
				event.clientY <= rect.top + rect.height &&
				rect.left <= event.clientX &&
				event.clientX <= rect.left + rect.width;

			if(!isInDialog && !this.disableClose) {
				this.close();
			}
		});

		this.element.addEventListener('op10.open', () => {
			if(!this.element.open) {
				this.open();
			}
		});

		this.element.addEventListener('op10.close', () => {
			if(this.element.open) {
				this.close();
			}
		});
	}

	toggle() {
		if(this.element.open) {
			this.close();
		} else {
			this.open();
		}
	}

	open() {
		this.element.showModal();
		this.addClass('is-opening');
		this.removeClass('is-closing');
		this.removeClass('is-closed');
		this.eventNamespaceFn(this.element, 'opening');

		if(this.rect != null) {
			this.element.style.top = this.rect.bottom + 'px';
			this.element.style.left = this.rect.left + 'px';
		}

		const eventHandler = () => {
			this.removeClass('is-opening');
			this.addClass('is-open');
			this.element.removeEventListener('animationend', eventHandler, false);
			this.eventNamespaceFn(this.element, 'opened');
		};

		this.element.addEventListener('animationend', eventHandler, false);
	}

	close() {
		this.addClass('is-closing');
		this.removeClass('is-opening');
		this.removeClass('is-open');
		this.eventNamespaceFn(this.element, 'closing');

		if(this.currentTarget != null) {
			this.currentTarget.classList.remove('is-active');
		}

		const eventHandler = () => {
			this.removeClass('is-closing');
			this.element.close();
			this.addClass('is-closed');
			this.element.removeEventListener('animationend', eventHandler, false);
			this.eventNamespaceFn(this.element, 'closed');
		};

		this.element.addEventListener('animationend', eventHandler, false);
	}

	addClass(...tokens: string[]) {
		this.element.classList.add(...tokens);
		this.triggers.forEach((trigger) => trigger.classList.add(...tokens));
	}

	removeClass(...tokens: string[]) {
		this.element.classList.remove(...tokens);
		this.triggers.forEach((trigger) => trigger.classList.remove(...tokens));
	}

	getInstance(){
		return this.element;
	}
}
